import { ColorVariant } from './colors'

export enum InventoryOrderReceiptReason {
  OVERAGE = 'Overage',
  DAMAGED = 'Damaged',
  EXPIRY_SHORT_DATED = 'Expiry - Short Dated',
  RECALLED = 'Recalled',
  OTHER = 'Other',
}

// Enum for inventory order statuses (includes CLOSED which is not in legacy shipments)
export enum InventoryOrderStatus {
  ORDERED = 'Ordered',
  PARTIAL = 'Partially received',
  RECEIVED = 'Received',
  CANCELLED = 'Cancelled',
  CLOSED = 'Closed',
}

// Enum for inventory order item statuses
export enum InventoryOrderItemStatus {
  ORDERED = 'Ordered',
  PARTIAL = 'Partially received',
  RECEIVED = 'Received',
  CANCELLED = 'Cancelled',
}

// Color mapping for inventory order statuses
export const InventoryOrderStatusColor: Record<
  InventoryOrderStatus,
  ColorVariant
> = {
  [InventoryOrderStatus.ORDERED]: ColorVariant.NORMAL,
  [InventoryOrderStatus.CANCELLED]: ColorVariant.DISABLED,
  [InventoryOrderStatus.RECEIVED]: ColorVariant.SUCCESS,
  [InventoryOrderStatus.PARTIAL]: ColorVariant.IMPORTANT,
  [InventoryOrderStatus.CLOSED]: ColorVariant.SUCCESS,
}

// Color mapping for inventory order item statuses
export const InventoryOrderItemStatusColor: Record<
  InventoryOrderItemStatus,
  ColorVariant
> = {
  [InventoryOrderItemStatus.ORDERED]: ColorVariant.NORMAL,
  [InventoryOrderItemStatus.PARTIAL]: ColorVariant.IMPORTANT,
  [InventoryOrderItemStatus.RECEIVED]: ColorVariant.SUCCESS,
  [InventoryOrderItemStatus.CANCELLED]: ColorVariant.DISABLED,
}
